export const groupNameMapper = (group_number: number): string => {
	let groupName = "";
	if (group_number === 220 || group_number === 219) groupName = "Brookshire Brothers, Inc";
	else if (group_number === 188) groupName = "Intercity Investment, Inc";
	else if (group_number === 225) groupName = "Panhandle First Bank";
	else if (group_number === 300) groupName = "Progressive Laboratories";
	return groupName;
};
